import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { BYMAT_LOGO } from "@/lib/brand";

const links = [
  { label: "Curriculum", href: "#curriculum" },
  { label: "Coach", href: "#coach" },
  { label: "Book", href: "#book" },
  { label: "Stories", href: "#stories" },
  { label: "FAQ", href: "#faq" },
];

export default function Navigation({ onCtaClick }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="top-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all ${
        scrolled
          ? "bg-[#0A1628]/85 backdrop-blur-md border-b border-slate-800"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-24 md:h-28">
        <Link to="/" className="flex items-center" data-testid="brand-logo">
          <img
            src={BYMAT_LOGO}
            alt="BYMAT Automation"
            className="h-20 md:h-24 w-auto object-contain mix-blend-screen"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-slate-300 hover:text-[#38BDF8] transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <Button
            onClick={onCtaClick}
            className="btn-yellow font-semibold uppercase tracking-wide text-xs rounded-full px-5 h-10"
            data-testid="nav-cta-button"
          >
            Book My Seat
          </Button>
        </div>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0A1628]/95 border-t border-slate-800 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-slate-300 hover:text-[#38BDF8]"
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
          <Button
            onClick={() => {
              setOpen(false);
              onCtaClick();
            }}
            className="btn-yellow font-semibold uppercase tracking-wide rounded-full"
            data-testid="mobile-nav-cta-button"
          >
            Book My Seat
          </Button>
        </div>
      )}
    </header>
  );
}
